module.exports = __webpack_public_path__ + "img/9788960869875.ec1f9d34.jpg";